// AcceptPage.js
import React, { useEffect, useState } from "react";
import { FaCheck } from "react-icons/fa";
import "../../invite.css";

const AcceptDncStagePage = () => {
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(null);
  const BASE_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const quotationId = new URLSearchParams(window.location.search).get("qid");

    const handleAccept = async () => {
      if (!quotationId) {
        setSuccess(false);
        setLoading(false);
        return;
      }

      try {
        const response = await fetch(`${BASE_URL}/Quotation/RespForExtraDisctByAdmin_ByMail`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ quotationid: quotationId, discountStatusID: 2 }),
        });
        setSuccess(response.ok);
      } catch (error) {
        console.error("Error:", error);
        setSuccess(false);
      } finally {
        setLoading(false);
      }
    };

    handleAccept();
  }, []);

  if (loading) {
    return <div className="center-screen"><p>Loading...</p></div>;
  }

  return (
    <div className="center-screen" style={{ backgroundColor: "#2c2139" }}>
      <div className="card-box">
        {success ? (
          <>
            <div className="icon"><FaCheck size={48} color="#a0b750" /></div>
            <h2 className="card-title">Approved</h2>
            <p className="card-msg">Quotation Discount has been Approved.</p>
          </>
        ) : (
          <>
            <div className="icon"><FaCheck size={48} color="#888" /></div>
            <h2 className="card-title">Error</h2>
            <p className="card-msg">Unable to approve quotation.</p>
          </>
        )}
      </div>
    </div>
  );
};

export default AcceptDncStagePage;
